import $ from "jquery";
import Bacon from "Bacon";

function getByRule(params) {
  var wildcard = params[0],
    channelId = params[1];
  return Bacon.fromPromise($.get("/ohjelmaopas/api/record/wildcard/matches", {
    wildcard: wildcard,
    channelId: channelId
  }));
}

export default {
  findByRule: getByRule
};



// WEBPACK FOOTER //
// ./web/js/ohjelmaopas/wildcard.js